import NeptuneElement from '../../NeptuneElement.js';

class Footer extends NeptuneElement {
    templateMarkup = `
        <footer>
            <span>© Ecolab 2026 Inc. All Rights Reserved.</span>
            <span id="separator">|</span>
            <div id="linksContainer">
                <a href="https://www.ecolab.com/sds" target="_blank">Safety Data Sheets</a>
                <span>|</span>
                <a href="https://www.ecolab.com/privacy-policy" target="_blank" >Privacy Policy</a>
                <span>|</span>
                <a href="https://www.ecolab.com/terms-of-use" target="_blank">Terms of Use</a>
            </div>
            <a href="https://www.ecolab.com/" target="_blank">
                <img alt="Company Logo" src="/src/components/chrome/assets/ecolab-logo/ecolab-logo.svg" />
            </a>
        </footer>
    `;

    componentCssUrl = '/src/components/chrome/footer/footer.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
        const year = new Date().getFullYear();
        const copyrightText = this.shadowRoot.querySelector('footer > span:first-child');
        if (copyrightText) {
            copyrightText.textContent = `© Ecolab ${year} Inc. All Rights Reserved.`;
        }
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return [];
    }

    attributeChangedCallback() {
        if (!this.isRendered) {
            return;
        }
    }
}

customElements.define('neptune-footer', Footer);
export default Footer;